import jwtDecode from 'jwt-decode';

import config from 'config';
import Radium from "radium";

import * as XLSX from 'xlsx';
import {saveAs} from 'file-saver';
import Colors from "./Colors";
import {fromBackendDate} from "./DateUtils";

export const generalModalStyles = {
    standardModalStyles: {
        overlay: {
            position: 'fixed',
            backgroundColor: config.modalBackgroundColor,
            zIndex: '50000',
            inset: 0,
            width: '100vw',
            height: '100vh',
        },
        content: {
            position: 'fixed',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            transform: 'translate(-50%, -50%)',
            borderRadius: '20px',
            padding: '30px',
            border: 'none',
            width: '80%',
            maxHeight: '90vh',
            overflow: 'auto',
            backgroundColor: 'var(--ds-bg-primary)',
        },
    },
    convHistoryModalStyles: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            // backgroundColor: 'none',
            zIndex: '2000',
        },
        content: {
            boxShadow: 'rgba(24, 62, 153, 0.2) 1px 5px 8px 0px',
            borderRadius: '10px',
            zIndex: '2000',
            height: '100%',
            position: 'unset',
            border: 'none',
            backgroundColor: 'var(--ds-bg-primary)',
            padding: 'none',
            marginLeft: 'auto',
            marginRight: '0',
            width: 'fit-content'
        },
    },
    datePickerModalStyles: {
        content: {
            /* react-modal writes its own white into the style attribute; this is what keeps a modal on the theme's surface */
            backgroundColor: 'var(--ds-bg-primary)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: '20px',
            transform: 'translate(-50%, -50%)',
        },
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
    },
    menuItemModalStyles: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
        content: {
            /* react-modal writes its own white into the style attribute; this is what keeps a modal on the theme's surface */
            backgroundColor: 'var(--ds-bg-primary)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            width: '640px',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            borderRadius: '20px',
            border: 'none',
            padding: 'none',
        },
    },
    convHeaderModalStyles: {
        content: {
            /* react-modal writes its own white into the style attribute; this is what keeps a modal on the theme's surface */
            backgroundColor: 'var(--ds-bg-primary)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            border: 'none',
            padding: '40px',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            width: '500px',
            borderRadius: '20px',
            maxHeight: '95%'
        },
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            /* Chat action modals can be opened from a conversation-history
               drawer (z-index 2001), so they must sit above that drawer. */
            zIndex: '3000',
        },
    },
    videoViewerModalStyles: {
        content: {
            width: '50%',
            top: '50%',
            left: '50%',
            bottom: 0,
            background: 'transparent',
            padding: 0,
            outline: 'none',
            border: 'none',
            overflow: 'visible',
            transform: 'translate(-50%, -50%)',
        },
        overlay: {
            zIndex: 2000,
            backgroundColor: config.modalBackgroundColor,
        },
    },
    statisticsConvModalStyles: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            zIndex: '2000',
        },
        content: {
            /* react-modal writes its own white into the style attribute; this is what keeps a modal on the theme's surface */
            backgroundColor: 'var(--ds-bg-primary)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: '20px',
            transform: 'translate(-50%, -50%)',
            padding: '40px',
            border: 'none',
            minWidth: '85%',
            maxWidth: '90%',
            height: '80%'
        },
    },
    confirmModalStyles: {
        overlay: {
            backgroundColor: config.modalBackgroundColor,
            /* Confirmations can be launched from drawers (for example deleting
               a bot from the mobile bot selector), so they must cover the
               drawer paper at z-index 2001. */
            zIndex: '3000',
        },
        content: {
            /* react-modal writes its own white into the style attribute; this is what keeps a modal on the theme's surface */
            backgroundColor: 'var(--ds-bg-primary)',
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            borderRadius: '20px',
            transform: 'translate(-50%, -50%)',
            padding: '40px',
            border: 'none',
        },
    }
};

export const silverInfoStyles = {
    info: {
        fontSize: '16px',
        lineHeight: '20px',
        fontWeight: 'inherit',
        color: Colors.silverBlueLite,
        marginLeft: '20px',
        userSelect: 'text',
        WebkitUserSelect: 'text',
        MozUserSelect: 'text',
        msUserSelect: 'text',
        cursor: 'text'
    }
}

export const filterInputStyle = {
    padding: '10px',
    borderRadius: '8px',
    border: '1px solid #ccc',
    width: 'calc(25% - 20px)',
    minWidth: '200px',
    backgroundColor: 'var(--ds-bg-primary)',
    boxShadow: 'inset 0 1px 3px rgba(0, 0, 0, 0.05)',
    fontSize: '14px'
};

export const titleStyles = {
    title: {
        color: Colors.blue,
        marginBottom: '20px',
        fontSize: '1.5rem',
    },
}

export const inputStyles = {
    input: {
        padding: '12px 16px',
        fontSize: '16px',
        width: '100%',
        borderRadius: '10px',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: '#ddd',
        backgroundColor: 'var(--ds-bg-primary)',
        color: 'var(--ds-text-primary)',
        outline: 'none',
        transition: 'all 0.3s ease-in-out',
    },
    inputFocus: {
        boxShadow: '0 0 0 2px rgba(43, 123, 255, 0.2)',
    },
};


export const MessageType = {
    quickReply: 'QUICK_REPLY',
    aiText: 'AI_TEXT',
    text: 'TEXT',
};

export const globalExportToExcel = ({data, columns, fileName = 'export.xlsx'}) => {
    if (!data || !columns) return;

    const formattedData = data.map(row => {
        const formattedRow = {};
        columns.forEach(col => {
            const value = typeof col.value === 'function' ? col.value(row) : row[col.value];
            formattedRow[col.label] = value;
        });
        return formattedRow;
    });

    const ws = XLSX.utils.json_to_sheet(formattedData);

    const colWidths = columns.map(col => {
        const header = col.label;
        const maxLen = formattedData.reduce((max, row) => {
            const cell = row[header];
            return Math.max(max, cell ? cell.toString().length : 0);
        }, header.length);
        return {wch: maxLen + 2};
    });
    ws['!cols'] = colWidths;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    const wbout = XLSX.write(wb, {bookType: 'xlsx', type: 'array'});
    saveAs(new Blob([wbout], {type: 'application/octet-stream'}), fileName);
};

export function filterElements(elements, filterString, additionalPredicate = () => false) {
    const filter = filterString.toLowerCase();

    return elements.filter((elem) => {
        const elemValues = Object.values(elem);
        let matches = false;
        elemValues.forEach((value) => {
            value = value ? value.toString().toLowerCase() : '';
            matches = value.includes(filter) || matches;
        });
        return matches || additionalPredicate(elem);
    });
}

export function sameDay(date1, date2) {
    return date1.getFullYear() === date2.getFullYear()
        && date1.getMonth() === date2.getMonth()
        && date1.getDate() === date2.getDate();
}

export function convertFormBackendDate(date) {
    return fromBackendDate(date);
}

export function convertToBackendDate(date) {
    return Math.floor(date.getTime());
}

export function validJWT(token) {
    try {
        const tokenData = jwtDecode(token);
        return Date.now() < tokenData.exp * 1000;
    } catch (e) {
        return false;
    }
}

export function getMemberRole(user) {
    const {authorities} = user;
    const {roles} = config;
    return roles.find(role => role.id === authorities[0]);
}

export function getMemberRoleId(user) {
    return getMemberRole(user).id;
}

export function hasChatPermission(user) {
    return ((getMemberRoleId(user) === config.rolesMap.agent) || (getMemberRoleId(user) === config.rolesMap.owner) || (getMemberRoleId(user) === config.rolesMap.admin));
}

export function hasBillingPermission(user) {
    return getMemberRoleId(user) === config.rolesMap.owner;
}

export function hasManagementPermission(user) {
    const memberRoleId = getMemberRoleId(user);
    return memberRoleId === config.rolesMap.admin || memberRoleId === config.rolesMap.owner;
}

export function getPermissions(user) {
    const permissions = [];
    if (hasManagementPermission(user)) {
        permissions.push(config.permissions.management);
    }

    if (hasBillingPermission(user)) {
        permissions.push(config.permissions.billing);
    }

    if (hasChatPermission(user)) {
        permissions.push(config.permissions.chat);
    }

    return permissions;
}

export function getUserClients(user, company) {
    return company.subs.filter(sub => user.subCompanyIds.includes(sub.id));
}

export function memberSupportsClient(member, client) {
    return member.subCompanyIds.includes(client.id);
}

export function isPositiveInteger(str) {
    const isPositive = /^(0|[1-9]\d*)$/.test(str);
    if (!isPositive) {
        throw new Error('Not A Positive Number');
    }
}

export function isPositiveNonZeroInteger(str) {
    const isPositive = /^([1-9]\d*)$/.test(str);
    if (!isPositive) {
        throw new Error('Not A Positive Number');
    }
}

function componentToHex(c) {
    const hex = c.toString(16);
    return hex.length === 1 ? `0${hex}` : hex;
}

export function rgbToHex(r, g, b) {
    return `#${componentToHex(r)}${componentToHex(g)}${componentToHex(b)}`.toUpperCase();
}

export function hexToRgb(hex) {
    const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
    } : null;
}

export function debounce(func, wait, immediate) {
    let timeout;
    return function (...args) {
        const context = this;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export function dummyTrue() {
    return true;
}

export function configuredRadium(component) {
    return Radium({
        plugins: [
            Radium.Plugins.mergeStyleArray,
            Radium.Plugins.checkProps,
            Radium.Plugins.resolveMediaQueries,
            Radium.Plugins.resolveInteractionStyles,
            Radium.Plugins.keyframes,
            Radium.Plugins.visited,
            Radium.Plugins.removeNestedStyles,
            // Radium.Plugins.prefix,
            Radium.Plugins.checkProps,
        ],
    })(component);
}

export function formatSecondsToHHMMSS(totalSeconds) {
    if (totalSeconds == null) return 'N/A';

    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return [hours, minutes, seconds]
        .map(unit => String(unit).padStart(2, '0'))
        .join(':');
}

export const getTodayDate = () => {
    const d = new Date();
    d.setHours(0, 0, 0, 0);
    return d;
};

export const getTomorrowDate = () => {
    const d = new Date();
    d.setDate(d.getDate() + 1);
    d.setHours(0, 0, 0, 0);
    return d;
};

export function groupReactionsHelper(messageData) {
    if(!messageData || (!messageData.userReaction && !messageData.operatorReaction)) return [];

    if(messageData.userReaction === messageData.operatorReaction) return [{emoji: messageData.userReaction , count: 2, hasOwn:true}];

    return [
        ...(messageData.userReaction ? [{emoji: messageData.userReaction, count: 1, hasOwn: false}] : []),
        ...(messageData.operatorReaction ? [{emoji: messageData.operatorReaction, count: 1, hasOwn: true}] : []),
    ];
}

export const isValidTime = (value) => {
    return /^([01]\d|2[0-3]):([0-5]\d)$/.test(value);
};



// WEBPACK FOOTER //
// ./src/utils/General.js